import { render, staticRenderFns } from "./flow5.vue?vue&type=template&id=48448caf&scoped=true&"
import script from "./flow5.vue?vue&type=script&lang=js&"
export * from "./flow5.vue?vue&type=script&lang=js&"
import style0 from "./flow5.vue?vue&type=style&index=0&id=48448caf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48448caf",
  null
  
)

export default component.exports